module.exports = __webpack_public_path__ + "img/card12.44137043.png";